// extracted by mini-css-extract-plugin
export var videoContainer = "_k5-0";
export var videoIframe = "_k5-3";
export var videoLink = "_k5-1";
export var videoOverlay = "_k5-4";
export var videoOverlayText = "_k5-5";
export var videoWrapper = "_k5-2";